import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DisplayNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[#^$<>+%!`&*|{}?/\\:=@]/.test(newValue)) {
      setError('Full name cannot contain #^$<>+%!`&*|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Full name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Full Name'
          id='display_name'
          aria-describedby='full-name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
        />
        {error ? (
          <FormHelperText id='full-name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='full-name-helper-text'>
            Enter your full name.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
